import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { doCreateSession } from '../store/actions';
import { postMessageSender } from '../lib/postMessager';
import { getParamsFromLocation } from '../lib/utils';

class Entrypoint extends PureComponent {
  state = {
    code: null,
  };

  componentDidMount() {
    const { location, onCreateSession } = this.props;
    const params = getParamsFromLocation(location);

    if (params.code) {
      onCreateSession(params.code);
    }

    postMessageSender({ action: 'ready' });
    window.addEventListener('message', this.handleTasks.bind(this));
  }

  handleTasks = event => {
    const PARENT_URL = process.env.REACT_APP_PARENT_URL;
    const origin_url = this.removeTrailingSlash(event.origin);

    if (PARENT_URL !== '*' && origin_url !== PARENT_URL) {
      console.warn(
        `URL ${origin_url} de origem não permitida. URL permitida: ${PARENT_URL}`,
      );
      return;
    }
  };

  removeTrailingSlash = name => {
    return name ? name.replace(/\/$/, '') : name;
  };

  render() {
    return null;
  }
}

Entrypoint.propTypes = {
  location: PropTypes.object.isRequired,
  onCreateSession: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  onCreateSession: authCode => dispatch(doCreateSession(authCode)),
});

export default connect(
  null,
  mapDispatchToProps,
)(Entrypoint);
